(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-layout"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-copy-link]');
    if (!button) return;

    var label = button.querySelector('[data-copy-label]');
    var url = button.getAttribute('data-copy-link');

    function confirmCopy() {
      if (!label) return;
      if (!button.hasAttribute('data-original-label')) {
        button.setAttribute('data-original-label', label.textContent);
      }
      label.textContent = button.getAttribute('data-copied-label');
      clearTimeout(button._copyTimer);
      button._copyTimer = setTimeout(function () {
        label.textContent = button.getAttribute('data-original-label');
      }, 2000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(confirmCopy, function () {});
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-cart-drawer]');
    if (!root) return;

    var itemsEl = root.querySelector('[data-cart-items]');
    var footEl = root.querySelector('[data-cart-foot]');
    var subtotalEl = root.querySelector('[data-cart-subtotal]');
    var discountRowEl = root.querySelector('[data-cart-discount-row]');
    var discountEl = root.querySelector('[data-cart-discount]');
    var cfg = root.dataset;

    var money = function (cents) {
      try {
        return new Intl.NumberFormat(cfg.locale, {
          style: 'currency',
          currency: cfg.currency
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    };

    var esc = function (s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };

    var lastCart = null;

    var setOpen = function (open) {
      root.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };

    var updateCounts = function (count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count < 1;
      });
    };

    var render = function (cart) {
      lastCart = cart;
      updateCounts(cart.item_count);
      if (!cart.items || cart.items.length === 0) {
        itemsEl.innerHTML = '<p class="drawer__empty">' + cfg.tEmpty + '</p>';
        footEl.hidden = true;
        return;
      }
      footEl.hidden = false;
      subtotalEl.textContent = money(cart.total_price);
      // Discount row only when something was actually taken off.
      var hasDiscount = cart.total_discount > 0;
      discountRowEl.hidden = !hasDiscount;
      discountEl.textContent = hasDiscount ? '-' + money(cart.total_discount) : '';
      itemsEl.innerHTML = cart.items.map(function (item) {
        var img = item.image
          ? '<img class="cart-line__image" src="' + esc(item.image) + '" alt="" width="64" height="64">'
          : '<span class="cart-line__image"></span>';
        var variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<div class="cart-line__variant">' + esc(item.variant_title) + '</div>'
          : '';
        var note = (item.properties && item.properties[cfg.noteKey]) || '';
        var noteHtml = note
          ? '<div class="cart-line__note">🎀 ' + esc(note) + '</div>'
          : '';
        var noteEditor = cfg.showNote !== 'true' ? '' :
          '<button type="button" class="cart-line__note-toggle" data-note-toggle>' +
            (note ? cfg.tNoteEdit : cfg.tNoteAdd) +
          '</button>' +
          '<div class="cart-line__note-editor" data-note-editor hidden>' +
            '<textarea rows="2" maxlength="200" data-note-input placeholder="' + esc(cfg.notePlaceholder) + '">' + esc(note) + '</textarea>' +
            '<div class="cart-line__note-actions">' +
              '<button type="button" class="cart-line__note-save" data-note-save>' + cfg.tNoteSave + '</button>' +
              '<button type="button" class="cart-line__note-cancel" data-note-cancel>' + cfg.tNoteCancel + '</button>' +
            '</div>' +
          '</div>';
        var was = item.original_line_price > item.final_line_price
          ? '<s class="cart-line__was">' + money(item.original_line_price) + '</s>'
          : '';
        var discountTitles = (item.line_level_discount_allocations || [])
          .filter(function (a) { return a.amount > 0 && a.discount_application; })
          .map(function (a) { return esc(a.discount_application.title); });
        var discountHtml = discountTitles.length
          ? '<div class="cart-line__discounts">' + discountTitles.join(', ') + '</div>'
          : '';
        return (
          '<div class="cart-line" data-key="' + esc(item.key) + '">' +
            img +
            '<div>' +
              '<div class="cart-line__title">' + esc(item.product_title) + '</div>' +
              variant +
              discountHtml +
              noteHtml +
              '<div class="cart-line__qty">' +
                '<button type="button" data-qty-down aria-label="-">&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty-up aria-label="+">+</button>' +
              '</div>' +
              noteEditor +
            '</div>' +
            '<div>' +
              '<div class="cart-line__price">' + was + money(item.final_line_price) + '</div>' +
              '<button type="button" class="cart-line__remove" data-remove>' + cfg.tRemove + '</button>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    };

    var refresh = function () {
      return fetch(cfg.cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render);
    };

    var change = function (key, quantity, properties) {
      var body = { id: key, quantity: quantity };
      if (properties) body.properties = properties;
      return fetch(cfg.changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('change failed');
        return r.json();
      }).then(render);
    };

    var add = function (variantId, quantity, properties, sellingPlan) {
      var line = { id: variantId, quantity: quantity || 1 };
      if (properties && Object.keys(properties).length) line.properties = properties;
      if (sellingPlan) line.selling_plan = sellingPlan;
      return fetch(cfg.addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [line] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        return refresh();
      }).then(function () {
        setOpen(true);
      });
    };

    var saveNote = function (key, qty, value, btn) {
      var item = null;
      if (lastCart && lastCart.items) {
        for (var i = 0; i < lastCart.items.length; i++) {
          if (lastCart.items[i].key === key) { item = lastCart.items[i]; break; }
        }
      }
      var props = {};
      if (item && item.properties) {
        Object.keys(item.properties).forEach(function (k) { props[k] = item.properties[k]; });
      }
      var val = (value || '').replace(/^\s+|\s+$/g, '');
      // An empty string clears the note: Shopify ignores a request that
      // tries to reset properties to an empty object.
      props[cfg.noteKey] = val;

      if (btn) {
        btn.classList.add('gs-loading');
        btn.disabled = true;
      }
      change(key, qty, props).then(function () {
        if (window.giftToast) window.giftToast.show(cfg.tNoteSaved);
      }).catch(function () {
        if (btn) {
          btn.classList.remove('gs-loading');
          btn.disabled = false;
        }
        if (window.giftToast) window.giftToast.show(cfg.tNoteError, 'error');
      });
    };

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { setOpen(false); return; }
      var line = e.target.closest('.cart-line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var qty = parseInt(line.querySelector('.cart-line__qty span').textContent, 10);

      if (e.target.closest('[data-note-toggle]')) {
        var editor = line.querySelector('[data-note-editor]');
        if (editor) {
          editor.hidden = !editor.hidden;
          if (!editor.hidden) editor.querySelector('[data-note-input]').focus();
        }
        return;
      }
      if (e.target.closest('[data-note-cancel]')) {
        var ed = e.target.closest('[data-note-editor]');
        if (ed) ed.hidden = true;
        return;
      }
      var saveBtn = e.target.closest('[data-note-save]');
      if (saveBtn) {
        var input = line.querySelector('[data-note-input]');
        saveNote(key, qty, input ? input.value : '', saveBtn);
        return;
      }

      if (e.target.closest('[data-qty-up]')) change(key, qty + 1).catch(refresh);
      else if (e.target.closest('[data-qty-down]')) change(key, Math.max(0, qty - 1)).catch(refresh);
      else if (e.target.closest('[data-remove]')) change(key, 0).catch(refresh);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    window.giftCart = {
      add: add,
      open: function () { refresh().then(function () { setOpen(true); }); },
      close: function () { setOpen(false); },
      refresh: refresh
    };

    refresh();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["favorites-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-fav-drawer]');
    if (!root) return;

    var itemsEl = root.querySelector('[data-fav-items]');
    var cfg = root.dataset;
    var KEY = 'gift:favorites';

    var base = (cfg.root || '/').replace(/\/$/, '');

    var read = function () {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; }
      catch (e) { return []; }
    };
    var write = function (arr) { localStorage.setItem(KEY, JSON.stringify(arr)); };
    var has = function (handle) { return read().indexOf(handle) !== -1; };

    var money = function (cents) {
      try {
        return new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    };

    var setOpen = function (open) {
      root.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };

    var updateCount = function () {
      var n = read().length;
      document.querySelectorAll('[data-fav-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n < 1;
      });
    };

    var syncButtons = function () {
      document.querySelectorAll('[data-fav-toggle]').forEach(function (btn) {
        btn.classList.toggle('is-active', has(btn.getAttribute('data-handle')));
      });
    };

    var render = function () {
      var handles = read();
      if (handles.length === 0) {
        itemsEl.innerHTML = '<p class="drawer__empty">' + cfg.tEmpty + '</p>';
        return;
      }
      itemsEl.innerHTML = '';
      handles.forEach(function (handle) {
        fetch(base + '/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p) return;
            var variant = null;
            for (var i = 0; i < p.variants.length; i++) {
              if (p.variants[i].available) { variant = p.variants[i]; break; }
            }
            if (!variant) variant = p.variants[0];
            var img = p.featured_image
              ? '<img class="fav-line__image" src="' + p.featured_image + '" alt="" width="64" height="64">'
              : '<span class="fav-line__image"></span>';
            var row = document.createElement('div');
            row.className = 'fav-line';
            row.innerHTML =
              img +
              '<div>' +
                '<a class="fav-line__title" href="' + base + '/products/' + handle + '">' + p.title + '</a>' +
                '<div class="fav-line__price">' + money(p.price) +
                  (p.compare_at_price > p.price ? ' <s class="fav-line__was">' + money(p.compare_at_price) + '</s>' : '') +
                '</div>' +
              '</div>' +
              '<div>' +
                '<button type="button" class="btn btn--accent fav-line__add" data-fav-add data-id="' + variant.id + '">' + cfg.tAdd + '</button>' +
                '<button type="button" class="fav-line__remove" data-fav-remove data-handle="' + handle + '">' + cfg.tRemove + '</button>' +
              '</div>';
            itemsEl.appendChild(row);
          });
      });
    };

    var toggle = function (handle) {
      var arr = read();
      var idx = arr.indexOf(handle);
      if (idx === -1) arr.push(handle);
      else arr.splice(idx, 1);
      write(arr);
      syncButtons();
      updateCount();
      if (root.getAttribute('aria-hidden') === 'false') render();
    };

    // Heart buttons anywhere on the page
    document.addEventListener('click', function (e) {
      var heart = e.target.closest('[data-fav-toggle]');
      if (heart) {
        e.preventDefault();
        toggle(heart.getAttribute('data-handle'));
      }
    });

    // Interactions inside the drawer
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { setOpen(false); return; }
      var add = e.target.closest('[data-fav-add]');
      if (add && window.giftCart) { setOpen(false); window.giftCart.add(parseInt(add.getAttribute('data-id'), 10), 1); return; }
      var rm = e.target.closest('[data-fav-remove]');
      if (rm) { toggle(rm.getAttribute('data-handle')); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    window.giftFav = {
      toggle: toggle,
      has: has,
      count: function () { return read().length; },
      open: function () { render(); setOpen(true); },
      close: function () { setOpen(false); }
    };

    syncButtons();
    updateCount();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-toast"] && !Shopify.designMode) return;
  try {
    (function () {
    var toast = document.querySelector('[data-gift-toast]');
    if (!toast) return;

    var msgEl = toast.querySelector('[data-gift-toast-msg]');
    var iconEl = toast.querySelector('.gift-toast__icon');
    var timer = null;

    window.giftToast = {
      show: function (message, type) {
        var isError = type === 'error';
        msgEl.textContent = message || '';
        if (iconEl) iconEl.textContent = isError ? '😔' : '🎀';
        toast.classList.toggle('gift-toast--error', isError);
        toast.classList.add('is-visible');
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          toast.classList.remove('is-visible');
        }, 2500);
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kampanya-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-kampanya-copy]');
    if (!button) return;
    var code = button.getAttribute('data-kampanya-copy');
    var message = button.getAttribute('data-copied') || code;

    function done() {
      if (window.giftToast) window.giftToast.show(message);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () {});
    } else {
      var field = document.createElement('textarea');
      field.value = code;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try {
        if (document.execCommand('copy')) done();
      } catch (e) {}
      document.body.removeChild(field);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-menu-drawer]');
    if (!root) return;

    var setOpen = function (open) {
      root.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    window.giftMenu = {
      open: function () { setOpen(true); },
      close: function () { setOpen(false); }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-quick-open]');
      if (openBtn) {
        var panel = openBtn.parentNode.querySelector('[data-variants]');
        if (panel) {
          var isHidden = panel.hasAttribute('hidden');
          document.querySelectorAll('[data-variants]').forEach(function (p) { p.setAttribute('hidden', ''); });
          if (isHidden) panel.removeAttribute('hidden');
        }
        return;
      }

      var addBtn = e.target.closest('[data-quick-add]');
      if (addBtn) {
        var id = parseInt(addBtn.getAttribute('data-id'), 10);
        var quick = addBtn.closest('[data-quick]');
        var props = null;
        var noteInput = quick ? quick.querySelector('[data-line-note]') : null;
        if (noteInput) {
          var note = noteInput.value.replace(/^\s+|\s+$/g, '');
          if (note && quick.getAttribute('data-note-key')) {
            props = {};
            props[quick.getAttribute('data-note-key')] = note;
          }
        }
        if (id && window.giftCart) window.giftCart.add(id, 1, props);
        if (noteInput) noteInput.value = '';
        var panel2 = addBtn.closest('[data-variants]');
        if (panel2) panel2.setAttribute('hidden', '');
        return;
      }

      // Click outside closes any open variant panel
      if (!e.target.closest('[data-quick]')) {
        document.querySelectorAll('[data-variants]').forEach(function (p) { p.setAttribute('hidden', ''); });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-lightbox"] && !Shopify.designMode) return;
  try {
    (function () {
    function initLightbox(root) {
      var box = root.querySelector('[data-lightbox]');
      var track = root.querySelector('[data-lightbox-track]');
      var viewport = root.querySelector('[data-lightbox-viewport]');
      var counter = root.querySelector('[data-lightbox-counter]');
      var closeBtn = root.querySelector('[data-lightbox-close]');
      var backdrop = root.querySelector('[data-lightbox-backdrop]');
      var opener = root.querySelector('[data-lightbox-open]');
      if (!box || !track || !viewport || box.dataset.lightboxInit === 'true') return;
      box.dataset.lightboxInit = 'true';

      var images = Array.prototype.slice.call(root.querySelectorAll('[data-lightbox-image]'));
      var count = images.length;
      var MAX_SCALE = 4;
      var TAP_SCALE = 2.5;

      var index = 0;
      var scale = 1;
      var tx = 0;
      var ty = 0;
      var sourcesLoaded = false;
      var lastFocus = null;

      function image() {
        return images[index];
      }

      // The picture inside the box is letterboxed by object-fit: contain, so
      // panning is clamped to the picture, not to the element box.
      function pictureSize(img) {
        var bw = img.offsetWidth;
        var bh = img.offsetHeight;
        var nw = img.naturalWidth;
        var nh = img.naturalHeight;
        if (!nw || !nh || !bw || !bh) return { w: bw, h: bh };
        var ratio = Math.min(bw / nw, bh / nh);
        return { w: nw * ratio, h: nh * ratio };
      }

      function clampPan() {
        var img = image();
        if (!img) return;
        var size = pictureSize(img);
        var limX = Math.max(0, (scale - 1) * size.w / 2);
        var limY = Math.max(0, (scale - 1) * size.h / 2);
        tx = Math.max(-limX, Math.min(limX, tx));
        ty = Math.max(-limY, Math.min(limY, ty));
      }

      function applyTransform(animate) {
        var img = image();
        if (!img) return;
        clampPan();
        img.style.transition = animate ? 'transform 0.25s ease' : 'none';
        img.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
        img.classList.toggle('is-zoomed', scale > 1.01);
      }

      function resetZoom(animate) {
        scale = 1;
        tx = 0;
        ty = 0;
        applyTransform(animate);
      }

      // Keeps the point under the finger/cursor fixed while the scale changes.
      function zoomAround(nextScale, px, py) {
        nextScale = Math.max(1, Math.min(MAX_SCALE, nextScale));
        if (nextScale === scale) return;
        tx = px - nextScale * (px - tx) / scale;
        ty = py - nextScale * (py - ty) / scale;
        scale = nextScale;
        if (scale <= 1.01) {
          tx = 0;
          ty = 0;
        }
      }

      function pointerOffset(clientX, clientY) {
        var rect = viewport.getBoundingClientRect();
        return {
          x: clientX - rect.left - rect.width / 2,
          y: clientY - rect.top - rect.height / 2
        };
      }

      function renderTrack(animate) {
        track.style.transition = animate ? '' : 'none';
        track.style.transform = 'translateX(' + index * -100 + '%)';
        if (counter && count > 1) {
          counter.textContent = (index + 1) + ' / ' + count;
        }
      }

      function goTo(target, animate) {
        if (!count) return;
        index = (target + count) % count;
        resetZoom(false);
        renderTrack(animate !== false);
      }

      function loadSources() {
        if (sourcesLoaded) return;
        sourcesLoaded = true;
        images.forEach(function (img) {
          var src = img.getAttribute('data-src');
          if (src && !img.getAttribute('src')) img.setAttribute('src', src);
        });
      }

      function open(startIndex) {
        loadSources();
        lastFocus = document.activeElement;
        box.hidden = false;
        document.body.style.overflow = 'hidden';
        index = startIndex || 0;
        resetZoom(false);
        renderTrack(false);
        if (closeBtn) closeBtn.focus();
      }

      function close() {
        box.hidden = true;
        document.body.style.overflow = '';
        resetZoom(false);
        // Hand the index back so the page gallery shows the same image.
        var api = root.galleryApi;
        if (api && typeof api.goTo === 'function') api.goTo(index);
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }

      if (opener) {
        opener.addEventListener('click', function () {
          var api = root.galleryApi;
          open(api && typeof api.getIndex === 'function' ? api.getIndex() : 0);
        });
      }
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (backdrop) backdrop.addEventListener('click', close);

      document.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        if (e.key === 'Escape') { close(); return; }
        if (scale > 1.01) return;
        if (e.key === 'ArrowRight') goTo(index + 1);
        if (e.key === 'ArrowLeft') goTo(index - 1);
      });

      // ---- Touch: swipe when not zoomed, pan when zoomed, pinch to zoom ----
      var startX = 0;
      var startY = 0;
      var startTx = 0;
      var startTy = 0;
      var dragDX = 0;
      var mode = null;
      var pinchDist = 0;
      var pinchScale = 1;
      var lastTapAt = 0;
      var lastTapX = 0;
      var lastTapY = 0;

      function distance(t1, t2) {
        var dx = t1.clientX - t2.clientX;
        var dy = t1.clientY - t2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      viewport.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) {
          mode = 'pinch';
          pinchDist = distance(e.touches[0], e.touches[1]);
          pinchScale = scale;
          return;
        }
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startTx = tx;
        startTy = ty;
        dragDX = 0;
        mode = scale > 1.01 ? 'pan' : 'swipe';
      }, { passive: true });

      viewport.addEventListener('touchmove', function (e) {
        if (mode === 'pinch' && e.touches.length === 2) {
          e.preventDefault();
          var d = distance(e.touches[0], e.touches[1]);
          if (!pinchDist) return;
          var mid = pointerOffset(
            (e.touches[0].clientX + e.touches[1].clientX) / 2,
            (e.touches[0].clientY + e.touches[1].clientY) / 2
          );
          zoomAround(pinchScale * (d / pinchDist), mid.x, mid.y);
          applyTransform(false);
          return;
        }
        if (e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;

        if (mode === 'pan') {
          e.preventDefault();
          tx = startTx + dx;
          ty = startTy + dy;
          applyTransform(false);
          return;
        }
        if (mode === 'swipe') {
          e.preventDefault();
          dragDX = dx;
          track.style.transition = 'none';
          track.style.transform =
            'translateX(calc(' + index * -100 + '% + ' + dx + 'px))';
        }
      }, { passive: false });

      viewport.addEventListener('touchend', function (e) {
        if (mode === 'pinch') {
          if (scale <= 1.01) resetZoom(true);
          mode = null;
          return;
        }

        if (mode === 'swipe') {
          track.style.transition = '';
          void track.offsetWidth;
          if (Math.abs(dragDX) > viewport.offsetWidth * 0.18) {
            goTo(dragDX < 0 ? index + 1 : index - 1);
          } else {
            renderTrack(true);
          }
        }

        // Double tap toggles zoom at the tapped point.
        var moved = Math.abs(dragDX) > 10;
        if (!moved && e.changedTouches.length === 1) {
          var t = e.changedTouches[0];
          var now = Date.now();
          var near = Math.abs(t.clientX - lastTapX) < 30 && Math.abs(t.clientY - lastTapY) < 30;
          if (now - lastTapAt < 300 && near) {
            var p = pointerOffset(t.clientX, t.clientY);
            zoomAround(scale > 1.01 ? 1 : TAP_SCALE, p.x, p.y);
            applyTransform(true);
            lastTapAt = 0;
          } else {
            lastTapAt = now;
            lastTapX = t.clientX;
            lastTapY = t.clientY;
          }
        }

        mode = null;
        dragDX = 0;
      });

      // ---- Pointer devices: wheel zooms, double click toggles, drag pans ----
      viewport.addEventListener('wheel', function (e) {
        if (box.hidden) return;
        e.preventDefault();
        var p = pointerOffset(e.clientX, e.clientY);
        zoomAround(scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), p.x, p.y);
        applyTransform(false);
      }, { passive: false });

      viewport.addEventListener('dblclick', function (e) {
        var p = pointerOffset(e.clientX, e.clientY);
        zoomAround(scale > 1.01 ? 1 : TAP_SCALE, p.x, p.y);
        applyTransform(true);
      });

      var mouseDown = false;
      viewport.addEventListener('mousedown', function (e) {
        if (scale <= 1.01) return;
        e.preventDefault();
        mouseDown = true;
        startX = e.clientX;
        startY = e.clientY;
        startTx = tx;
        startTy = ty;
      });
      window.addEventListener('mousemove', function (e) {
        if (!mouseDown) return;
        tx = startTx + (e.clientX - startX);
        ty = startTy + (e.clientY - startY);
        applyTransform(false);
      });
      window.addEventListener('mouseup', function () {
        mouseDown = false;
      });

      // Keep the viewer in step when the page gallery moves (thumbs, variants).
      root.addEventListener('gallery:change', function (e) {
        if (box.hidden) return;
        goTo(e.detail.index, false);
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-product-page]').forEach(initLightbox);
    }

    initAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-search-drawer]');
    if (!root) return;

    var cfg = root.dataset;
    var input = root.querySelector('[data-search-input]');
    var results = root.querySelector('[data-search-results]');
    var base = (cfg.root || '/').replace(/\/$/, '');
    var timer = null;

    var setOpen = function (open) {
      root.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) setTimeout(function () { input.focus(); }, 50);
    };

    var render = function (q, products) {
      if (!products || products.length === 0) {
        results.innerHTML = '<p class="search-drawer__empty">' + cfg.tEmpty + '</p>';
        return;
      }
      var cards = products.map(function (p) {
        var img = p.image
          ? '<img class="search-suggestion__image" src="' + p.image + '" alt="" loading="lazy">'
          : '<span class="search-suggestion__image"></span>';
        var price = (typeof p.price === 'string' && p.price)
          ? '<span class="search-suggestion__price">' + p.price + '</span>'
          : '';
        return '<a class="search-suggestion" href="' + p.url + '">' + img +
          '<span class="search-suggestion__title">' + p.title + '</span>' + price + '</a>';
      }).join('');
      results.innerHTML = '<div class="search-suggestions">' + cards + '</div>' +
        '<a class="search-drawer__all" href="' + cfg.searchUrl + '?q=' + encodeURIComponent(q) + '">' +
        (root.getAttribute('data-t-view-all') || 'See all results') + '</a>';
    };

    var search = function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      fetch(base + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data && data.resources && data.resources.results ? data.resources.results.products : [];
          render(q, products);
        })
        .catch(function () {});
    };

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(search, 250);
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    window.giftSearch = {
      open: function () { setOpen(true); },
      close: function () { setOpen(false); }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["terms-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    // The cart re-renders this dialog on every quantity change, so the element
    // is looked up on each interaction rather than cached at load.
    var find = function () {
      return document.querySelector('[data-terms-modal]');
    };

    var close = function (modal) {
      if (!modal) return;
      if (typeof modal.close === 'function' && modal.open) modal.close();
      else modal.removeAttribute('open');
    };

    document.addEventListener('click', function (e) {
      var modal = find();
      if (!modal) return;

      if (e.target.closest('[data-terms-open]')) {
        e.preventDefault();
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', '');
        return;
      }

      if (e.target.closest('[data-terms-close]')) {
        close(modal);
        return;
      }

      // Clicking the backdrop closes the dialog; clicks inside must not.
      if (e.target === modal) close(modal);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
